import { configureStore } from '@reduxjs/toolkit';
import { indexSlice } from './slices';

export const store = configureStore({
    devTools: false,
    reducer: {
        index: indexSlice.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
})